import styled from 'styled-components';

// import 'antd/lib/grid/style/index.css';

// import 'antd/lib/tooltip/style/index.css';

// import './css/checkbox.css';

export const PageTitle = styled.div`
  margin: 0 auto 30px auto;
  width: auto;
  max-width: 1068px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  div.pageTitle {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-top: 10px;
    width: 100%;
  }
  p {
    margin-left: 10px;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.21;
    letter-spacing: 0.01px;
    color: #999999;
    span {
      text-transform: capitalize;
      font-size: 14px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      color: #74a50a;
    }
  }
  span {
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.28;
    letter-spacing: 0.01px;
    text-align: left;
    color: #619b30;
  }
  div.voltar {
    display: flex;
    align-items: center;
    flex-direction: row;
    margin-right: 20px;
    padding-top: 2px;
    button {
      display: flex;
      align-items: center;
      flex-direction: row;
      border: none;
      background: none;
      color: #619b30;
      font-weight: bold;
    }
  }
`;
export const BoxInfoUpdate = styled.div`
  position: relative;
  div {
    div {
      width: 160px;
      border-radius: 6px;
      border: solid 1px #b2b2b2;
      background-color: #e5e5e5;
      position: absolute;
      right: 0;
      padding: 5px 13px;
      display: flex;
      flex-direction: row;
      span {
        font-size: 12px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.17;
        letter-spacing: 0.01px;
        text-align: left;
        color: #898989;
        display: block;
        margin-left: 15px;
      }
    }
    p {
      position: absolute;
      right: 2px;
      top: 50px;
      font-size: 10px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1;
      letter-spacing: 0.01px;
      text-align: left;
      color: #999999;
    }
    p:nth-child(2) {
      top: 65px;
    }
  }
`;

export const BoxContent = styled.div`
  width: 1068px;
  min-height: 600px;
  padding: 20px;
  margin: 0 auto;
  border: solid 0.8px #d9d9d9;
  background-color: #f7f7f7;

  .borderTest {
    border: 1px solid blue;
  }

  div.boxSpin {
    display: flex;
    justify-content: center;
    padding: 50px;
  }

  div.BoxAuthContainer {
    margin: 20px auto;
  }
  hr {
    opacity: 0.1;
    display: block;
    margin: 30px 0;
  }
  div.title {
    padding: 45px;
    h2 {
      font-size: 24px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.21;
      letter-spacing: 0.01px;
      text-align: center;
      color: #282828;
      span {
        color: #398ca1;
        font-weight: bold;
      }
    }
  }
`;

export const Content = styled.div`
  width: 75%;
  margin: 0 auto;

  div.ant-row {
    margin-bottom: 25px;
  }

  p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    color: #282828;
  }
`;

export const BoxForm = styled.div`
  div.boxUltimaPontuacaoNPS,
  div.boxQuestion {
    padding-top: 2px;
    display: flex;
    flex-direction: row;
    align-items: center;
    span {
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      text-align: left;
      color: #398ca1;
    }
    input {
      width: 80px;
    }
  }
  div.ButtonTooltip {
    color: #fff;
    span {
      width: 13px;
      height: 13px;
      background-color: #b4b4b4;
      border-radius: 50%;
      display: block;
      color: #fff;
      font-size: 8px;
      display: fex;
      justify-content: center;
      align-items: center;
      margin-left: 3px;
    }
  }  
  
  div.boxRedeAssitencialCnpj,
  div.boxQuestion {
    padding-top: 2px;
    flex-direction: row;
    align-items: center;
    span {
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      text-align: left;
      color: #398ca1;
    }
    input {
      width: 159px;
    }
  }

  div.boxRedeAssitencialRazao,
  div.boxQuestion {
    padding-top: 2px;
    flex-direction: row;
    align-items: right;
    span {
      font-size: 13px;
      font-weight: bold;
      font-stretch: normal;
      font-style: normal;
      line-height: 1.23;
      letter-spacing: 0.01px;
      text-align: left;
      color: #398ca1;
    }
    input {
      width: 520px;
    }
  }
`;

export const TitleSection = styled.h4`
  font-size: 16px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.21;
  text-align: left;
  color: #398ca1;
  margin-bottom: 20px;
`;

export const BoxInput = styled.div`
  div.radiosProtocolos {
    .ant-col {
      margin-bottom: 10px;
      span:nth-child(1) {
        float: left;
      }
      label {
        cursor: pointer;
      }
      p {
        font-size: 13px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.23;
        letter-spacing: 0.01px;
        text-align: left;
        color: #1f5f6f;
        position: absolute;
        top: 4px;
        left: 50px;
        right: 10px;
      }
    }
  }

  width: 100%;
  /* padding: 20px; */
  display: flex;
  flex-direction: column;

  /* border: 1px solid blue; */
  p {
    font-size: 11px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 2;
    letter-spacing: 0.01px;
    text-align: left;
    color: #282828;
  }

  /* input */

  input[type='text'],
  input[type='number'] {
    width: 100%;
    background: #ffffff;
    border: 0;
    border-radius: 4px;
    height: 35px;
    padding: 0 15px;
    color: #282828;
    margin: 0 0 0 0;
    box-shadow: inset 0px 1px 0px 0px #c7c7c794;
    border: 1px solid #c7c7c794;
    &::placeholder {
      color: #282828;
      font-size: 12px;
    }
    &:disabled {
      background-color: #f6f6f6;
    }
  }

  span.errorField {
    color: #cc0000;
    font-size: 9px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;

    letter-spacing: 0px;
    margin-bottom: 5px;
  }

  div.inlineRadios {
    display: flex;
    justify-content: space-between;
    flex-direction: row;
  }
`;

export const BoxRadios = styled.div`
  width: 201.7px;
  padding: 10px 20px;
  border-radius: 3px;
  border: solid 0.5px;
  border-color: ${props => (props.active ? '#398ca1' : 'transparent')};
  background-color: ${props => (props.active ? 'rgba(35, 95, 110, 0.16)' : '')};
  &.v-large {
    width: 100%;
  }
  p {
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.01px;
    text-align: left;
    color: ${props => (props.accessLevelActive ? '#398ca1' : '#999999')};
    margin-top: 7px;
  }

  .item-description {
    white-space: normal;
    font-size: 12px;
    line-height: 14px;
    font-weight: normal;
  }

  .ant-radio-wrapper {
    display: flex;
    color: #398ca1;
    font-size: 13px;
    font-weight: bold;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum', 'tnum';
    cursor: pointer;
    span {
      color: ${props => (props.active ? '#398ca1' : '#898989')};
      font-size: 13px;
      font-weight: bold;
      line-height: 24px;
      float: left;
      display: inline-block;
      letter-spacing: 0px;

      display: inline-flex;
      flex-wrap: wrap;
      align-items: center;
    }
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #398ca1;
    &:hover {
      border-color: #398ca1;
    }
    &:focus {
      border-color: #398ca1;
    }
  }

  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #398ca1;
  }

  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: #fff;
    background: #398ca1;
    border-color: #398ca1;
  }
  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
    color: #fff;
    background: #398ca1;
    border-color: #398ca1;
  }

  .ant-radio-inner::after {
    position: absolute;
    top: 4px;
    left: 4px;
    display: table;
    width: 12px;
    height: 12px;
    background-color: #398ca1;
    border-top: 0;
    border-left: 0;
    border-radius: 8px;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    opacity: 0;
    -webkit-transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    content: ' ';
  }
  .ant-radio-inner {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 22px;
    height: 22px;
    background-color: #fff;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px;
    border-radius: 100px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

  /*  */

  .ant-radio-checked::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #398ca1;
    border-radius: 50%;
    visibility: hidden;
    -webkit-animation: antRadioEffect 0.36s ease-in-out;
    animation: antRadioEffect 0.36s ease-in-out;
    animation-fill-mode: none;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    content: '';
  }
`;

export const BoxRadiosInline = styled.div`
  height: 85px;

  padding: 10px 20px;
  border-radius: 3px;
  border: solid 0.5px;
  border-color: ${props => (props.active ? '#398ca1' : 'transparent')};
  background-color: ${props => (props.active ? 'rgba(35, 95, 110, 0.16)' : '')};

  /* border: 1px solid blue; */

  margin-bottom: 10px;

  p {
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.01px;
    text-align: left;
    color: ${props => (props.active ? '#398ca1' : '#999999')};
    margin-left: 30px;
  }

  .ant-radio-wrapper {
    color: #398ca1;
    font-size: 13px;
    font-weight: bold;
    font-variant: tabular-nums;
    line-height: 1.5;
    list-style: none;
    font-feature-settings: 'tnum', 'tnum';
    white-space: nowrap;
    cursor: pointer;
    span {
      color: ${props => (props.active ? '#398ca1' : '#898989')};
      font-size: 13px;
      font-weight: bold;
      line-height: 24px;
      float: left;
      display: inline-block;
      letter-spacing: 0px;
    }
  }

  .ant-radio-checked .ant-radio-inner {
    border-color: #398ca1;
    &:hover {
      border-color: #398ca1;
    }
    &:focus {
      border-color: #398ca1;
    }
  }

  .ant-radio-wrapper:hover .ant-radio,
  .ant-radio:hover .ant-radio-inner,
  .ant-radio-input:focus + .ant-radio-inner {
    border-color: #398ca1;
  }

  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):hover {
    color: #fff;
    background: #398ca1;
    border-color: #398ca1;
  }
  .ant-radio-group-solid
    .ant-radio-button-wrapper-checked:not(.ant-radio-button-wrapper-disabled):active {
    color: #fff;
    background: #398ca1;
    border-color: #398ca1;
  }

  .ant-radio-inner::after {
    position: absolute;
    top: 4px;
    left: 4px;
    display: table;
    width: 12px;
    height: 12px;
    background-color: #398ca1;
    border-top: 0;
    border-left: 0;
    border-radius: 8px;
    -webkit-transform: scale(0);
    -ms-transform: scale(0);
    transform: scale(0);
    opacity: 0;
    -webkit-transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    transition: all 0.3s cubic-bezier(0.78, 0.14, 0.15, 0.86);
    content: ' ';
  }
  .ant-radio-inner {
    position: relative;
    top: 0;
    left: 0;
    display: block;
    width: 22px;
    height: 22px;
    background-color: #fff;
    border-color: #d9d9d9;
    border-style: solid;
    border-width: 1px;
    border-radius: 100px;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
  }

  /*  */

  .ant-radio-checked::after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 1px solid #398ca1;
    border-radius: 50%;
    visibility: hidden;
    -webkit-animation: antRadioEffect 0.36s ease-in-out;
    animation: antRadioEffect 0.36s ease-in-out;
    animation-fill-mode: none;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
    content: '';
  }

  label.ant-radio-wrapper {
    line-height: 1;
  }

  div.contentBoxRadiosInline {
    padding-left: 23px;
    margin-bottom: -3px;
  }

  .ant-radio {
    position: absolute;
    margin-top: 18px;
  }
`;

export const BoxCheckboxs = styled.div`
  .ant-checkbox + span {
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 0;
    letter-spacing: 0.01px;
    text-align: left;
    color: #235f6e;
    /* margin-top: -10px; */
    display: inline-block;
  }
  p {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: left;
    color: #398ca1;

    display: block;
    padding-left: 30px;
    padding-right: 50px;
  }

  .ant-checkbox {
    top: 0px;
  }

  .ant-checkbox-group {
    .ant-col {
      div.CheckboxBg {
      }
    }
  }
`;

export const CheckboxBg = styled.div`
  padding: 15px;
  border-radius: 3px;
  border: solid 0.5px;
  border-color: ${props => (props.selecionado ? '#398ca1 ' : 'transparent')};
  background-color: ${props => (props.selecionado ? '#d6e0e4 ' : '')};
  margin: 5px 10px 10px 5px;

  p {
    color: ${props => (props.selecionado ? '#398ca1 ' : '#898989')};
  }

  /* label.ant-checkbox-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    border: 1px solid red;

    div.alignCheckbox {
      align-self: center;
      border: 1px solid blue;

      p {
      }
    }
  } */

  span.ant-checkbox {
    span.ant-checkbox-inner {
      border-color: ${props => props.selecionado && '#398ca1'};
      background-color: ${props => props.selecionado && '#398ca1'};

      &::after {
        position: absolute;
        display: table;
        border: 2px solid
          ${props => (props.selecionado ? '#fff' : 'transparent')};
        border-top: 0;
        border-left: 0;
        transform: rotate(45deg) scale(1) translate(-50%, -50%);
        opacity: 1;
        transition: all 0.2s cubic-bezier(0.12, 0.4, 0.29, 1.46) 0.1s;
        content: ' ';
      }
    }
  }
`;

export const Label = styled.span`
  font-size: 13px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: 0.01px;
  text-align: left;
  color: #282828;
  margin-bottom: 10px;
  display: block;
  > span {
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.15;
    letter-spacing: 0.01px;
    text-align: left;
    color: #999999;
  }
`;

export const ButtonBox = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 50px;
  button {
    /* width: 90px; */
    height: 34px;
    padding: 0 50px;
    border-radius: 3.5px;
    background-color: #74a50a;
    border: none;
    color: #fff;
    display: flex;
    align-items: center;
  }
`;

export const BoxdiagnosticoTerapeutico = styled.div`
  div.diagnotico_terapeutico_hemodinamica {
    padding-top: 20px;
  }

  div.ant-row {
    margin-bottom: 0px;
  }
`;

export const ButtonTop = styled.div`
  display: flex;
  justify-content: center;
  button {
    width: 162px;
    height: 34px;
    border-radius: 3.5px;
    background-color: #00698b;
    border: none;
    color: #fff;
    font-size: 13px;
    line-height: 1.15;
    letter-spacing: normal;
    text-align: center;
    color: #ffffff;
  }
`;

export const ExceptionsBox = styled.div`
  width: 75%;
  margin: 0 auto 50px auto;
  padding: 30px;
  border-radius: 3px;
  background-color: #f5d4d4;
  border: solid 0.5px #cc0000;

  p {
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.63;
    letter-spacing: 0.01px;
    margin-bottom: 15px;
    color: #cc0000;
  }
  > div {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 10px;
    svg {
      margin-right: 8px;
    }
  }
`;
